import { z } from "zod";

export const searchParamsSchema = z.object({
  videoStyleId: z.string().optional(),
  tab: z.enum(["vst", "sst"]).optional(),
});

export type SortColumn = "displayName" | "id" | "updatedOn";
export type SortDirection = "asc" | "desc";
